// extracted by mini-css-extract-plugin
module.exports = {"rename":"Rename_rename__2zynH"};